import React from 'react';
import { Props } from '../types';

export const RocheStagingHero = ({
  blok: {
    variant,
    headline,
    content,
    slotted_image: slottedImage,
  },
  slot,
}: Props): JSX.Element => {
  const imageProps = slottedImage?.[0];

  if (!imageProps) {
    return (
      <roche-staging-hero slot={slot} variant={variant}>
        <h1 className="hero__headline" slot="headline">{headline}</h1>
        {content && <div className="hero__text" slot="text">{content}</div>}
      </roche-staging-hero>
    );
  }

  const {
    brightcove_id: brightcoveId, fullscreen, position, ratio,
  } = imageProps;

  const {
    filename, title, copyright, alt,
  } = imageProps.src;

  return (
    <roche-staging-hero slot={slot} variant={variant}>
      <h1 className="hero__headline" slot="headline">{headline}</h1>
      {content && <div className="hero__text" slot="text">{content}</div>}
      {variant === 'hero--variant-b' && (
        <roche-image
          slot="image"
          src={filename}
          caption={title}
          copyright={copyright}
          alt={alt}
          {...(brightcoveId && { 'brightcove-id': brightcoveId })}
          fullscreen={fullscreen}
          position={position}
          ratio={ratio}
        />
      )}
    </roche-staging-hero>
  );
};
